import { render, staticRenderFns } from "./Resubscribe.vue?vue&type=template&id=adff2de8&scoped=true&"
import script from "./Resubscribe.vue?vue&type=script&lang=js&"
export * from "./Resubscribe.vue?vue&type=script&lang=js&"
import style0 from "./Resubscribe.vue?vue&type=style&index=0&id=adff2de8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adff2de8",
  null
  
)

export default component.exports